/**
 * One string for several values, for a comparison by value: a fetch key, a reset token. It is
 * never parsed back, so it has no delimiter to collide with a value. The parts are named and
 * sorted by name, so the order in which a caller writes them does not change the key.
 */

import type { ScopeKeyPart } from '@/types/common';

/** `parts` may be an interface: its fields are the named parts. */
export function getScopeKey<K extends { [F in keyof K]: ScopeKeyPart }>(parts: K): string {
    const entries = Object.entries(parts)
        .sort(([one], [other]) => one.localeCompare(other))
        .map(([name, value]) => [name, value ?? null]);
    return JSON.stringify(entries);
}
